/**
 * @author Denis Sobolev, Ryan Gladstone, Vinny DeFrancesco
 */

function refineExplainerController(
  $scope,
  $translate,
  _,
  languageProvider,
  schemaService,
  urlService,
  moment,
  timezoneService
) {
  // Only use US format if the locale is `en-us`
  $scope.dateFormatString = languageProvider.locale === 'en-us'
    ? 'h:mm a EEE MMM d'
    : 'h:mm a EEE d MMM';

  schemaService.getStatuses('workflow').then((data) => {
    $scope.workflowStatuses = data;
  });

  schemaService.getStatuses('publish').then((data) => {
    $scope.publishStatuses = data;
  });

  $scope.refine = {
    contentTypes: [],
    pitches: []
  };

  $scope.filters = $scope.filterSet.filters;
  $scope.contentTypes = $scope.filterSet.getFilter('contentType');


  const contentTypesMap = {
    article: $translate.instant('ARTICLE'),
    video: $translate.instant('VIDEO'),
    gallery: $translate.instant('GALLERY'),
    graphic: $translate.instant('GRAPHIC')
  };

  const pitchesMap = {
    pitched: $translate.instant('PITCHED').toLowerCase(),
    'not watching': $translate.instant('NOT_WATCHING').toLowerCase(),
    watching: $translate.instant('WATCHING').toLowerCase(),
    saving: $translate.instant('SAVING').toLowerCase(),
    used: $translate.instant('USED').toLowerCase()
  };

  $scope.$watch('filters.searchTermCopy.value', (value) => {
    $scope.refine.searchTerm = value;
  });

  $scope.$watch('filters.tbd.value', (value) => {
    $scope.refine.tbd = value || null;
  });

  const getDisplayTime = (dateValue) => moment(dateValue)
    .tz(timezoneService.userTimezone)
    .format(timezoneService.userTimeHourFormat === 12 ? 'h:mm a ddd D MMM' : 'H:mm ddd D MMM');

  const getRelativeDate = (offsetString) => {
    const date = new Date();
    const relativeValue = parseInt(offsetString, 10) * 1000;
    return date.getTime() + relativeValue;
  };

  const resolveFilterDateValue = (filterVal) => {
    if (filterVal) {
      if (timezoneService.isRelativeDate(filterVal)) {
        return getRelativeDate(filterVal);
      }
      return urlService.getEpochTime(filterVal) * 1000;
    }
    return null;
  };

  $scope.$watch('filters.startDate.value', (value) => {
    $scope.refine.starting = resolveFilterDateValue(value);

    if ($scope.refine.starting) {
      $scope.refine.startingFormatted = getDisplayTime($scope.refine.starting);
    }
  });

  $scope.$watch('filters.endDate.value', (value) => {
    $scope.refine.ending = resolveFilterDateValue(value);

    if ($scope.refine.ending) {
      $scope.refine.endingFormatted = getDisplayTime($scope.refine.ending);
    } else {
      $scope.refine.endingFormatted = null;
    }
  });

  $scope.$watch('filters.pitchesOnly.value', (value) => {
    $scope.refine.pitchesOnly = value ? $translate.instant('ONLY_PITCHED_STORIES') : null;
  });

  $scope.$watch('filters.pitchStatus.value', (value) => {
    let payload = [];

    if (typeof value === 'string') {
      payload = [value];
    }

    if (value && Array.isArray(value) && value.length) {
      value.forEach((val) => {
        payload.push(pitchesMap[val]);
      });
    }

    $scope.refine.pitchStatus = payload && payload.length ? payload.join(', ') : null;
  });

  $scope.$watch('filters.workflowStatus.value', (value) => {
    $scope.refine.workflow = schemaService.getStatusString('workflow', value);
  });

  $scope.$watch('filters.publishStatus.value', (value) => {
    $scope.refine.publish = schemaService.getStatusString('publish', value);
  });

  $scope.$watch('contentTypes.value', (currentValue) => {
    const payload = [];

    if (currentValue) {
      const value = [].concat(currentValue);
      value.forEach((val) => {
        payload.push(contentTypesMap[val]);
      });
    }
    $scope.refine.contentTypes = payload.join(', ');
  });

  $scope.$watch('filters.childPlans.value', (value) => {
    $scope.refine.childPlansAreHidden = value === 'off';
  });


  $scope.$watch('planType', (value) => {
    if (value) {
      if (value === 'sections') {
        $scope.refine.pitchStatus = null;
      } else {
        $scope.refine.pitchesOnly = null;
      }
    }
  });
}

const controllerArray = [
  '$scope',
  '$translate',
  '_',
  'languageProvider',
  'schemaService',
  'urlService',
  'moment',
  'timezoneService',
  refineExplainerController
];

export default function (ngModule) {
  ngModule.controller('refineExplainerController', controllerArray);
}
